module.exports = __webpack_public_path__ + "static/media/marker-new.3d00b220.png";